import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBIcon } from "mdbreact";
import { useToasts } from "react-toast-notifications";
import "./style.css";
import {
  ENDPOINT,
  Cloudinary,
  FailedLogo,
  axioKit,
} from "./../../../../../services/utilities";
import {
  UPLOAD,
  RESET,
  SetCOMPANY,
  OverrideActivePlatform,
} from "./../../../../../services/redux/slices/assets/persons/auth";
import QrCodeGenerator from "../../../../../components/qrCode";
import ImageCropper from "../../../../../components/images/cropper";

export default function QrCodePage() {
  const { activePlatform, token } = useSelector(({ auth }) => auth);
  const { company, branch } = activePlatform;
  const [preview, setPreview] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  // small banner: same image as the sidebar logo
  const smallBanner =
    preview ||
    `${Cloudinary.getEndpoint()}/${company?.lid || ""}/companies/${
      company?.name
    }/logo.png`;

  useEffect(() => {
    dispatch(RESET());
  }, [dispatch]);

  const handleUpload = (base64) => {
    if (!company?._id) {
      addToast("No company is linked to this branch.", {
        appearance: "error",
      });
      return;
    }

    setPreview(base64);
    setIsUploading(true);

    dispatch(
      UPLOAD({
        data: Cloudinary.buildFileForm(
          base64,
          `companies/${company.name}`,
          "logo"
        ),
        token,
      })
    )
      .then((action) => {
        const lid = action?.payload?.imgId;
        if (!lid) throw new Error("Small banner upload failed.");

        return axioKit
          .update("assets/companies", { _id: company._id, lid }, token)
          .then(() => {
            const updatedCompany = { ...company, lid };
            dispatch(SetCOMPANY(updatedCompany));
            dispatch(
              OverrideActivePlatform({
                ...activePlatform,
                company: updatedCompany,
                branch: { ...branch, companyId: updatedCompany },
              })
            );
            addToast("Small Banner Successfully Updated.", {
              appearance: "success",
            });
          });
      })
      .catch((error) => {
        setPreview("");
        addToast(error?.message || "Small banner upload failed.", {
          appearance: "error",
        });
      })
      .finally(() => setIsUploading(false));
  };

  return (
    <>
      <div className="QrCode-container" style={{ backgroundColor: "#007dfe" }}>
        <div className="QrCode-header">
          <div className="QrCode-banner">
            <img
              key={smallBanner}
              draggable={false}
              src={smallBanner}
              alt={company?.name || "Small Banner"}
              onError={(e) => (e.target.src = FailedLogo)}
            />
          </div>
          <span className="QrCode-tagline">{company?.tagline}</span>
        </div>
        <div className="QrCode-body">
          <div className="QrCode-img-container">
            <QrCodeGenerator
              size={200}
              value={`${ENDPOINT}/subscriber/${company?._id}`}
            />
          </div>
          <span className="QrCode-text">Scan here to go to the Website</span>
        </div>

        <div className="QrCode-footer">
          <span>Powered by Pinoy iMD - Pinoy Medical Diagnostic</span>
        </div>
      </div>

      <div className="QrCode-actions">
        <ImageCropper
          handleUpload={handleUpload}
          modalSize="lg"
          cropSize={{ width: 230, height: 80 }}
          isUpload
          inputId={`qr-banner-crop-${company?._id || "default"}`}
          label={
            <>
              <MDBIcon
                icon={isUploading ? "spinner" : "upload"}
                pulse={isUploading}
                className="mr-2"
              />
              {isUploading ? "Uploading..." : "Upload Small Banner"}
            </>
          }
          accept={".png"}
        />
        <small className="text-muted d-block">
          PNG, 230×80. Also used as the sidebar logo.
        </small>
      </div>
    </>
  );
}
